var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
var StepMixin = /** @class */ (function (_super) {
    __extends(StepMixin, _super);
    function StepMixin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.currentStep = 1;
        return _this;
    }
    Object.defineProperty(StepMixin.prototype, "stepsArray", {
        // steps will be provided as a prop in child components
        get: function () {
            return this.steps || [1, 2, 3, 4];
        },
        enumerable: false,
        configurable: true
    });
    StepMixin.prototype.nextStep = function () {
        if (this.currentStep + 1 <= this.stepsArray[this.stepsArray.length - 1]) {
            this.currentStep++;
            this.scrollToTop(true);
        }
    };
    StepMixin.prototype.prevStep = function () {
        if (this.currentStep - 1 >= 1) {
            this.currentStep--;
            this.scrollToTop(false);
        }
    };
    StepMixin.prototype.scrollToTop = function (isForward) {
        if (isForward === void 0) { isForward = false; }
        this.$nextTick(function () {
            var element = document.getElementById('vue-layout');
            var isIOS = /iP(hone|od|ad)/.test(window.navigator.userAgent);
            var activeElement = document.activeElement;
            if (activeElement && typeof activeElement.blur === 'function') {
                activeElement.blur();
            }
            var forceAllParentsToTop = function (node) {
                var current = node;
                while (current) {
                    current.scrollTop = 0;
                    current = current.parentElement;
                }
            };
            var scrollTargets = [
                document.scrollingElement,
                document.documentElement,
                document.body,
                document.getElementById('all_parts'),
                document.querySelector('.content'),
                document.querySelector('.main-wrapper'),
                element
            ];
            var forceTop = function () {
                window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
                scrollTargets.forEach(function (target) {
                    if (target) {
                        target.scrollTop = 0;
                    }
                });
                if (element) {
                    forceAllParentsToTop(element);
                }
            };
            if (element) {
                try {
                    element.scrollIntoView({ behavior: isIOS ? 'auto' : 'smooth', block: 'start' });
                }
                catch (error) {
                    element.scrollIntoView(true);
                }
            }
            window.requestAnimationFrame(function () {
                forceTop();
            });
            setTimeout(forceTop, 140);
            if (isForward) {
                setTimeout(forceTop, 320);
                setTimeout(forceTop, 620);
            }
        });
    };
    Object.defineProperty(StepMixin.prototype, "hasNextStep", {
        get: function () {
            return this.currentStep < this.stepsArray.length;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StepMixin.prototype, "hasPrevStep", {
        get: function () {
            return this.currentStep > 1;
        },
        enumerable: false,
        configurable: true
    });
    StepMixin = __decorate([
        Component
    ], StepMixin);
    return StepMixin;
}(Vue));
export default StepMixin;
